/**
 * Вложенное сообщение с провода. grpc-gateway (protojson с emitUnpopulated)
 * шлёт НЕЗАДАННОЕ вложенное сообщение как `null`, а не опускает ключ, —
 * `.prefault({})`/`.default()`/`.optional()` в одиночку закрывают только `undefined`.
 */
import { z } from 'zod'

/** `null` читается как опущенный ключ. */
export function nullAsMissing<S extends z.ZodType>(schema: S) {
  return z.preprocess((v) => (v === null ? undefined : v), schema)
}

/** Объект с пустым умолчанием: `null` и опущенный ключ читаются одинаково. */
export function nestedObject<T extends z.ZodRawShape>(shape: T) {
  return nullAsMissing(z.object(shape).prefault({} as never))
}

/** Необязательная схема, терпящая `null` (→ `undefined`). */
export function optionalNested<S extends z.ZodType>(schema: S) {
  return nullAsMissing(schema.optional())
}
